<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.61194 1.126L5.73794 5L9.61194 8.875L8.87394 9.613L4.99994 5.737L1.12594 9.612L0.387939 8.874L4.26194 4.999L0.387939 1.126L1.12594 0.388L4.99994 4.262L8.87394 0.388L9.61194 1.126Z"
      fill="black"
    />
  </svg>
</template>